;(function ( $ ) {

  // can't define variables ahead, Drupal doesn't have them ready.

  $.fn.assetTabSizing = function()
  {
    var $sub_asset = $('.sub-assets');
    // the titles don't have a width to get while the parent is display:none
    // so let it appear for an instant (only to the browser, of course!)
    $sub_asset.parent().css({ 'visibility':'hidden', 'display':'block' });
    // run the positioning function
    assetTabPlacement();
    // then reset the styles on the parent
    $sub_asset.parent().css({ 'visibility':'', 'display':'' });
  };

  $.fn.assetTabReset = function()
  {
    // going back to accordion
    $('.sub-assets').find('.type').each(function(){
      $(this).css({ 'left':'auto', 'height':'auto' });
    });
  };

  function assetTabPlacement()
  {
    var $sub_asset           = $('.sub-assets'),
        $all_section_titles  = $sub_asset.find('.type'),
        $first_section_title = $all_section_titles.first().attr('id');

    $all_section_titles.each(function(){
      var $title      = $(this),
          $title_prev = $title.parent().prev().find('.type');

      if ( ($title.attr('id') === $first_section_title) ) {
        $(this).css({left:'0'});
      } else {
        var find_left  = $title_prev.position(),
            find_width = $title_prev.width();

        $title.css({ 'left' : Math.round( find_left.left + $title.parent().prev().find('p').width() ) }); // add " + 1" for margin
      }
    });
  }

}( jQuery ));
